module.exports = "/images/more-filled.svg?935e12d5d7d43edb2c1e0bd34b1786da";